/* eslint-disable sonarjs/cognitive-complexity */
import {
  BaSeButton,
  BaSeContainer,
  BaSeDataTable,
  BaSeDialogContext,
  BaSeIcon,
  BaSeSmall1,
  BaSeTheme,
} from '@base/react';
import { format } from 'date-fns';
import React, { useState } from 'react';
import { useInterviewController } from '../../../../../../hooks/controllers/interview-controller';
import { useModule } from '../../../../../../hooks/module/module';
import { cpfMask } from '../../../../../../utils/formatters/cpfMask';
import ConfirmGenerateCertificate from './confirm-generate-certificate';
import FormHeaderGenerateCertificate from './form-header-generate-certificate';
import { Container, FooterContainer } from './modal-generate-certificate-style';

const formatDate = (date) => {
  return format(new Date(date), 'yyyy/MM/dd').replaceAll('/', '-');
};

function ModalGenerateCertificate({ values, begin, end, closeModal }) {
  const { showNotification } = React.useContext(BaSeDialogContext);
  const { gerarCertificado } = useInterviewController();
  const { moduleSelected } = useModule();

  const [confirmGenerate, setConfirmGenerate] = useState(false);
  const [data, setData] = useState(values);

  const [initialDate, setInitialDate] = useState(new Date(begin));
  const [finalDate, setFinalDate] = useState(new Date(end));
  const [cargaHoraria, setCargaHoraria] = React.useState(60);
  const [loadingButton, setLoadingButton] = React.useState(false);

  const remove = React.useCallback(
    (value) => {
      const response = data.filter((item) => {
        return item !== value;
      });
      setData(response);
    },
    [data, setData],
  );

  const hasMutiple = () => {
    if (data.length > 1) {
      return {
        accessorKey: 'lixeira',
        header: 'Remover',
        mapper: ({ values }) => (
          <BaSeIcon
            name="trash-alt"
            size="16"
            onClick={() => remove(values)}
            description="icon-lightulb-als"
            color={BaSeTheme.colors.institucionais.cinzaSebrae30}
          />
        ),
      };
    }
    return {
      accessorKey: 'lixeira',
      header: '',
      mapper: ({ values }) => <></>,
    };
  };
  const configTable = [
    {
      accessorKey: 'name',
      header: 'Nome completo',
      mapper: ({ values }) => {
        return (
          <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
            {values.name}
          </BaSeSmall1>
        );
      },
    },
    {
      accessorKey: 'cpf',
      header: 'CPF',
      mapper: ({ values }) => (
        <BaSeSmall1 color={BaSeTheme.colors.institucionais.cinzaSebrae45}>
          {cpfMask(values.cpf)}
        </BaSeSmall1>
      ),
    },
    hasMutiple(),
  ];

  React.useEffect(() => {
    if (!moduleSelected?.id) return;
    if (moduleSelected?.id === 3) {
      setCargaHoraria(44);
    }
  }, [moduleSelected]);
  const sendDataToGenerateCertificate = React.useCallback(() => {
    setLoadingButton(true);
    const dataParsed = {
      beginDate: formatDate(new Date(initialDate), 'yyyy/MM/dd'),
      endDate: formatDate(new Date(finalDate), 'yyyy/MM/dd'),
      courseHours: cargaHoraria.toString(),
      generateCertificateClass: true,
      idsInterview: data.map(({ idInterview }) => idInterview),
    };
    gerarCertificado(dataParsed)
      .then(() => {
        showNotification({
          message: 'Sucesso!',
          supportMessage:
            'Solicitação enviada. Aguarde a geração do certificado.',
          secondsToClose: 5,
          color: 'confirmation',
        });
      })
      .finally(() => {
        setLoadingButton(false);
        closeModal('');
      });
  }, [
    initialDate,
    finalDate,
    cargaHoraria,
    data,
    gerarCertificado,
    showNotification,
    closeModal,
  ]);

  return (
    <Container>
      {confirmGenerate ? (
        <ConfirmGenerateCertificate
          cargaHoraria={cargaHoraria}
          initialDate={initialDate}
          finalDate={finalDate}
        />
      ) : (
        <>
          <FormHeaderGenerateCertificate
            cargaHoraria={cargaHoraria}
            setCargaHoraria={setCargaHoraria}
            finalDate={finalDate}
            setFinalDate={setFinalDate}
            initialDate={initialDate}
            setInitialDate={setInitialDate}
          />
          <BaSeContainer
            withAutoScroll
            style={{
              height: '50vh',
            }}
          >
            <BaSeDataTable
              config={configTable}
              shadow="0"
              items={data}
              width="99%"
              hasHeader={false}
            />
          </BaSeContainer>
        </>
      )}

      {confirmGenerate ? (
        <FooterContainer>
          <BaSeButton
            value="Confirmar"
            isLoading={loadingButton}
            onClick={() => {
              // setConfirmGenerate((prev) => !prev);
              sendDataToGenerateCertificate();
            }}
            color={BaSeTheme.colors.defaultColors.black}
          />
          <BaSeButton
            value="Revisar"
            type="secondary"
            color={BaSeTheme.colors.defaultColors.black}
            onClick={() => setConfirmGenerate((prev) => !prev)}
          />
        </FooterContainer>
      ) : (
        <FooterContainer>
          <BaSeButton
            value="Gerar certificado"
            onClick={() => {
              if (
                initialDate === undefined ||
                finalDate === undefined ||
                cargaHoraria === 0 ||
                cargaHoraria === undefined ||
                cargaHoraria === ''
              ) {
                showNotification({
                  message: 'Erro!',
                  supportMessage:
                    'É necessário preencher todas as informações sobre o seminário!',
                  secondsToClose: 5,
                  color: 'destructive',
                });
                return;
              }
              setConfirmGenerate((prev) => !prev);
            }}
            color={BaSeTheme.colors.defaultColors.black}
          />
          <BaSeButton
            value="Cancelar"
            type="secondary"
            color={BaSeTheme.colors.defaultColors.black}
            onClick={() => closeModal()}
          />
        </FooterContainer>
      )}
    </Container>
  );
}

export default ModalGenerateCertificate;
